export const END_POINTS = {
  FILECHUNKS: "securityscan/newscan/file-chunks",
  PROCESSUPLOAD: "securityscan/process-uploads",
  LOGIN: "secure-auth/login",
  MFA: "secure-auth/mfa",
  REFRESH_TOKEN: "secure-auth/token",
  LOGOUT: "secure-auth/logout",
  SSO_LOGIN: "secure-auth/sso-login",
  AUTHENTICATE_SINGLE_SIGNIN: "authentication/sso",
  VENDORS: "securityscan/vendors-models",
  MASTER_TEMPLATE_UPLOAD: "securityscan/master-template/upload",
  MASTER_TEMPLATE_DEVICE_MAPPING: "securityscan/master-template/device-mapping",
  MASTER_TEMPLATE_LIST: "securityscan/master-template/list",
  USER_DETAILS: "authentication/user-details",
  ORG_ROLES: "authentication/org-roles",
  ROLE_PERMISSIONS: "authentication/roles",
  ACTIVATE_REGISTRATION: "authentication/user-registration",
  SAVE_USERS: "authentication/role-permissions",
  IS_NEW_USER: "securityscan/device-count",
  CLOUD_SCANS: "securityscan/cloud-scans",
  GLOBAL_DASHBOARD_REGION: "authentication/global-filter-Ldata",
  GLOBAL_DASHBOARD_DEVICE: "securityscan/global-filter-device-list",
  SAVE_FILTER: "authentication/save-filters",
  CLOUD_AGENT: "securityscan/agent",
  NewAGENT_LINKED_SCANS: "securityscan/agent",
  SCHEDULE_FREQUENCY: "securityscan/schedule-frequency",
  CLOUD_SCHEDULE_FREQUENCY: "securityscan/cloud-frequency-schedule",
  DOWNLOAD_SAMPLE_FILE: "securityscan/sample-file-download",
  FILE_UPLOAD_PROCESS: "securityscan/newscan/process-uploads",
  CD_COMPLIANCE_POSTURE: "securityscan/cd-compliance-posture",
  /** Consolidated DoT / MBSS API — switch on body.action (list_controls, update_control, summary_score, get_settings, update_settings, history) */
  DOT_COMPLIANCE: "securityscan/dot-compliance",
  ON_PREM_MY_SCAN: "securityscan/scans",
  DOWNLOAD_LINK_ENDPOINT: "engine/generate-download-link",
  //FILE_UPLOAD_PROCESS: "securityscan/newscan/process-uploads",
  ON_PREM_MY_SCAN_RESCAN: "securityscan/rescan",
  ON_PREM_SCHEDULED_SCAN: "securityscan/scheduled-myscans",
  ROLE_NAME: "authentication/role-name",
  DELETE_ROLE: "authentication/delete-role",
  DASHBOARD_REGION_WISE: "securityscan/dashboard-regionwise",
  ONPREM_ASSETS_LOWEST_COMPLIANCE: "securityscan/dashboard-assets-compliance",
  // ONPREM_ASSETS_LOWEST_CVE_SCORE: "securityscan/dashboard-assets-cve", // Deprecated: Removed from backend. Logic merged into DASHBOARD_ASSESTS_LOWEST_SCORE (dashboard-assets) via POST with payload: { module: "dashboard-assets-cve", scope: "on_premise" }
  // DASHBOARD_CLOUD_ACCOUNTS: "securityscan/dashboard-cloud-accounts", // Deprecated: Removed from backend. Logic merged into DASHBOARD_SCORE via POST with payload: { module: "dashboard-cloud-accounts" }
  DASHBOARD_CLOUD_LOWEST_SCORE: "securityscan/dashboard-cloud-assets",
  // DASHBOARD_TOP_MISCONFIGURATIONS: "securityscan/dashboard-misconfiguration", // Deprecated: Removed from backend. Logic merged into DASHBOARD_ASSESTS_LOWEST_SCORE (dashboard-assets) via POST with payload: { module: "dashboard-misconfiguration", scope: "<cloud | on_premise>" }
  DASHBOARD_CLOUD_LOWEST_COMPLIANCE: "securityscan/dashboard-assets-compliance",
  DASHBOARD_TAGS: "securityscan/cd-tags",
  MY_SCAN_RENAME: "securityscan/rename-scan",
  ADD_AGENT: "securityscan/agent",
  EXTEND_ENROLLMENT: "securityscan/agent",
  ACCOUNT_LIST: "securityscan/accounts-list",
  PASSWORD_CONFIRMATION: "secure-auth/password-validation",
  CVE_LIST: "securityscan/cve-list",
  // New Scan endpoints for Agent2
  SCAN_TYPES: "securityscan/scan-types",
  CREDENTIALS: "securityscan/credentials",
  CREATE_SCAN: "securityscan/scans",
  AGENT_LINKED_SCANS: "securityscan/agent-scans",
  MY_SCAN_SCHEDULE_SCAN: "securityscan/schedule-info",
  MY_SCAN_SCHEDULE_FREQUENCY: "securityscan/schedule-frequency",
  MY_SCAN_SCHEDULED_SCAN: "securityscan/schedule-scan",
  DISCOVERY_EDIT_SCHEDULE: "securityscan/edit-schedule",
  MY_SCAN_DETAILS: "securityscan/scan-status",
  DASHBOARD_TOP_CVES: "securityscan/cve/search_cve",
  DASHBOARD_RECENT_TICKETS: "securityscan/recent-tickets",
  VPN: "securityscan/vpn",
  VPN_TEST: "securityscan/test-vpn",
  ORG_PORT_HINTS: "securityscan/org-port-hints",
  CONNECTION_STATUS: "securityscan/connection-status",
  CHANGE_PASSWORD: "secure-auth/password/change",
  TOKEN_VALIDATION: "authentication/token-validation",
  Edit_User: "authentication/edit-user",
  DELETE_USER: "authentication/delete-user",
  ACTIVATE_USER: "authentication/user-activation",
  DEACTIVATE_USER: "authentication/user-activation",
  RESEND_PASSWORD: "authentication/forgot-password",
  CHANGE_ROLE: "authentication/update-user-role",
  Eidt_Org: "authentication/edit-org",
  Jira_Integration: "jira-events/jira_integration_create",
  VALIDATE_JIRA: "jira-events/validate-jira",
  DEVICE_LIST: "securityscan/on-prem/asset-list",
  DEVICE_LIST_V2: "securityscan/on-prem/asset-list-v2",
  ASSETS_NOT_SCANNED_LIST: "securityscan/dashboard-assets-not-scanned-list",
  ASSETS_NOT_SCANNED: "securityscan/on-prem/assets-not-scanned",
  DEVICE_LIST_CLOUD: "securityscan/resources-list",
  AWS_INVENTORY: "securityscan/aws-inventory",
  // DECOMM_DEVICE_LIST: "securityscan/decommissioned-devices", // Deprecated: Removed from backend. Logic merged into DECOMMISSION_DEVICES (securityscan/decommission-recommission) via POST with payload: { module: "decommissioned-devices" }
  SSH_UPLOAD: "securityscan/new-multi-scan",
  SSH_FIELD: "secure-scan/new-scan",
  API_FIELD: "secure-scan/new-scan",
  AUTH: "secure-auth/authentication",
  REGISTER: "secure-auth/user-registration",
  RESET: "authentication/forgot-password",
  CREATE_PASSWORD: "secure-auth/change-password",
  APEXIQ_INTEGRATION: "secure-auth/apexa-registration",
  EDIT_ORG_IMAGE: "authentication/org-pic-upload",
  EDIT_USER_IMAGE: "authentication/user-pic-upload",
  USER_PERMISSION: "authentication/user-permissions",
  GET_USER_IMAGE: "authentication/user-image",
  RESET_PASS_TOKEN_API: "authentication/token-validation",
  RESEND_EMAIL: "authentication/resend-email",
  INVITE_SUPER_ADMIN: "authentication/org-registration",
  GET_ORG_IMAGE: "authentication/org-image",
  PROFILE_SETUP_GET_LEVELS: "authentication/list-region-labels",
  MUTE_NOTIFICATION: "authentication/mute-notification",
  Asset_SUMMARY_DATA: "securityscan/asset-summary-data",
  REPORT_DOWNLOAD: "reports/request-report",
  Asset_SUMMARY_REPORT: "securityscan/asset-summary-report",
  DELETE_ORG: "authentication/org-data-delete",
  RESCAN: "securityscan/rescan",
  Asset_Compliance_Report: "securityscan/asset-compliance-data",
  RISK_ACCEPTANCE_SUMMARY: "securityscan/whitelist-graphs",
  RISK_ACCEPTANCE_HISTORY: "securityscan/whitelist-history",
  RISK_ACCEPTANCE_TABLE: "securityscan/security-info",
  GLOBAL_SEARCH: "scansearch/search",
  SECURITYSCAN_DATA: "securityscan/search-ip",
  // DECOMMISSION_DEVICES: Used via POST for:
  // - { action: "decommission", device_id: [...] } to decommission devices
  // - { action: "recommission", device_id: [...] } to recommission devices
  // - { module: "decommissioned-devices" } to fetch decommissioned devices list
  DECOMMISSION_DEVICES: "securityscan/decommission-recommission",
  DELETE_DEVICES: "securityscan/delete-device",
  RESCAN_RECOMMISSION: "securityscan/recom-rescan",
  // GLOBAL_DASHBOARD_REGION: "authentication/global-filter-region",
  UPDATE_DEVICE: "securityscan/device-region",
  CREDENTIAL_MGMT: "securityscan/asset-credentials",
  // DASHBOARD_MITRE: "securityscan/dashboard-mitre", // Deprecated: Removed from backend. Logic merged into DASHBOARD_MISCONFIGURATION (dashboard-overall-vulnerabilities) via POST with payload: { module: "dashboard-mitre" }
  // DASHBOARD_BENCHMARK_SCORE: "securityscan/dashboard-benchmark-score", // Deprecated: Removed from backend. Logic merged into DASHBOARD_ASSESTS_LOWEST_SCORE (dashboard-assets) via POST with payload: { module: "dashboard-benchmark-score", scope: "<on_premise | cloud | all>", bench_name: "CIS" }
  // DASHBOARD_VPN_AGENT_COUNT: "securityscan/dashboard-vpn-agent-count", // Deprecated: Removed from backend. Logic merged into DASHBOARD_SCORE via POST with payload: { module: "dashboard-vpn-agent-count" }
  // DASHBOARD_ASSETS_DETAILS: "securityscan/dashboard-assets-details", // Deprecated: Removed from backend. Logic merged into DASHBOARD_SCORE via POST with payload: { module: "dashboard-assets-details" }
  // DASHBOARD_ASSETS_NOT_SCANNED: "securityscan/dashboard-assets-not-scanned", // Deprecated: Removed from backend. Logic merged into DASHBOARD_SCORE via POST with payload: { module: "dashboard-assets-not-scanned" }
  DASHBOARD_CYBER_RESILIENCE_TREND:
    "securityscan/dashboard-cyber-resilience-trend",
  DASHBOARD_SCORE: "securityscan/dashboard-score",
  SCHEDULE_LIST: "securityscan/scheduled-myscans",
  RE_SCAN_CRED: "securityscan/rescan-with-cred",
  MAP_CRED: "securityscan/asset-credential-mapping",
  CREDENTIAL_TYPES: "securityscan/credential-types",
  RISK_ACCEPTANCE_DETAILS: "securityscan/assets",
  RISK_ACCEPTANCE_DEATILS_HEADER: "securityscan/control-details",
  RISK_ACCEPTANCE_DETAILS_TOTAL_COUNT: "securityscan/control-asset-details",
  RISK_ACCEPTANCE_DETAILS_DESC: "securityscan/controls-by-parameter",
  RISK_ACCEPTANCE_DETAILS_ACCEPT_RISK: "securityscan/whitelist_history_details",
  DEVICE_MANAGEMENT_RESCAN: "securityscan/devices-list-od",
  DASHBOARD_MISCONFIGURATION: "securityscan/dashboard-overall-vulnerabilities",
  DASHBOARD_CVE_VULNERABILITIES: "securityscan/dashboard-cve-vulnerabilities",
  DASHBOARD_INTELLISCORE: "securityscan/dashboard-score",
  DASHBOARD_ASSEST_SUMMARY: "securityscan/asset-compliance-summary",
  // DASHBOARD_ASSESTS_LOWEST_SCORE: Used via GET for lowest score device list, and POST with:
  // - { module: "dashboard-misconfiguration", scope: "<cloud | on_premise>" } for top misconfigurations
  // - { module: "dashboard-assets-cve", scope: "on_premise" } for lowest CVE score assets
  // - { module: "dashboard-benchmark-score", scope: "<on_premise | cloud | all>", bench_name: "CIS" } for benchmark score
  DASHBOARD_ASSESTS_LOWEST_SCORE: "securityscan/dashboard-assets",
  SCHEDULE_ASSET_POPUP: "securityscan/schedule-asset-popup",
  DEVICE_CYBER_RESILIENCE_SCAN_DATES: "securityscan/scaned-device-dates",
  CYBER_RESILIENCE_DASHBOARD: "securityscan/dashboard-cyber-resilience-trend",
  DEVICE_PERAMETER: "securityscan/scaned-device-parameters",
  CONFIG_DIFF: "securityscan/config-file-differ",
  CONFIG_DIFF_MODIFIED: "securityscan/config-new-file-differ",
  ASSETS_CRITICALITY: "securityscan/asset-criticality-dropdown",
  ASSETS_CRITICALITY_UPDATE: "securityscan/asset-criticality",
  ASSET_COMPLIANCE: "securityscan/asset-compliance-details",
  ASSET_COMPLIANCE_DETAILS: "securityscan/asset-compliance-controls",
  SECURITY_SCAN_CHAT: "securityscan/chat",
  CD_COMPLIANCE: "securityscan/cd-compliance",
  DASHBOARD_COMPLIANCE: "securityscan/dashboard-compliance-trend",
  DASHBOARD_PROFILE_IMAGE: "authentication/user-image",
  CYBERRESILIENCE_DASHBOARD_CVE: "securityscan/daily-event-data-cve",
  CYBERRESILIENCE_DASHBOARD_ON_PREM: "securityscan/daily-event-data-on_premise",
  CYBERRESILIENCE_DASHBOARD_DAILY: "securityscan/daily-event-data",
  DISCOVERY_AGENT: "securityscan/discovery-items",
  DISCOVERY_DETAILS_IP: "securityscan/search-ip",
  DISCOVERY_SCAN_HISTORY: "securityscan/discovery-scan-history",
  REPORT_REQUESTS: "reports/report-requests",

  //report endpoints
  REPORT_TYPES: "reports/report-list",
  REPORT_OVERALL_HISTORY: "/reports/reports-history",
  SCAN_SUMMARY: "securityscan/scan-summary-device-manual",
  MANUAL_REVIEW_SUBMIT: "securityscan/manual-review-submit",
  SAVE_MANUAL: "securityscan/save-manual",
  REPORT_UPDATE_DELETE: "reports/reports-update-delete",
  COMPLIANCE_FILTERS: "securityscan/compliance-filters",
  SOFTWARE_DATA: "securityscan/software-list",
  WMI_SOFTWARE_LIST: "securityscan/wmi-asset-level/software",
  WMI_SOFTWARE_BY_IP: "securityscan/wmi-asset-level/software-by-ip",
  WMI_ASSET_DETAILS: "securityscan/wmi-asset-level/asset-details",
  WMI_CVE_LOOKUP: "securityscan/wmi-asset-level/cve-lookup",
  DEVICE_OWNER_BY_ID: "securityscan/device-owner-by-id",

  //config diff endpoints
  ASSET_CONFIG_DIFF: "securityscan/config-assets",
  ASSET_CONFIG_DIFF_HISTORY: "securityscan/config-diff",
  ASSET_CONFIG_DIFF_TREND_GRAPH: "securityscan/config-diff",
  CONFIG_DIFF_EVENTS_History: "securityscan/config-event",
  CONFIG_DIFF_EVENTS_TREND_GRAPH: "/securityscan/config-diff-trend",
  ASSET_VIEWSUMMARY: "securityscan/config-diff-summary",
  FILE_SUMMARY: "securityscan/config-file-summary",
  DASHBOARD_PREFERENCES: "authentication/dashboard-preferences",

  // rule management endpoints

  RULE_MANAGEMENT_RULES: "agent/rules",
  RULEMANAGEMENT_TEST: "securityscan/call-generate-inputs",
  RULE_MANAGEMENT_DEPLOY: "agent/rules",

  //new scan screns

  NEW_SCAN_TYPES: "secure-scan/new-scan",
  MY_SCAN_V2:"securityscan/scans-v2",
  MY_SCAN_SCHEDULES:"securityscan/scheduled-myscans-v2",
  VALIDATE_IP: "securityscan/validate-ip",
  CANCEL_SCHEDULE: "securityscan/cancel-schedule",
  NEW_MULTI_SCAN: "securityscan/new-multi-scan",
  WHITELIST_REQUESTS: "securityscan/whitelist-requests",
  WHITELIST_APPROVE: "securityscan/whitelist-approve",
};